// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__4+zJ2","wrap_input":"SearchInput_wrap_input__-rZRj","crossIcon":"SearchInput_crossIcon__vOyRu"};